module.exports = __webpack_public_path__ + "media/images/emblems/Pfaffnau_LU-9c28c6f6c963212886158cc40cfbb790.png";